// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kj-0";